import { useState } from 'react';
import AttestatiService from '../services/AttestatiService/AttestatiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useAttestati = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingGeneraAttestato: false,
    isLoadingDownloadAttestato: false,
    isPrintingEnvelope: false,
  });

  const [modalState, setModalState] = useState({
    showModalGeneraAttestato: false,
    showSelectRecipientModal: false,
  });

  // --- Genera attestato ---
  const generaAttestato = async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingGeneraAttestato: true }));
    try {
      const response = await AttestatiService.generaAttestato(data);
      alertService.success("Attestato generato con successo", {autoClose: true});
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingGeneraAttestato: false }));
    }
  }

  // --- Scarica attestato ---
const downloadAttestato = async (data, filename) => {
    setLoadingState((s) => ({ ...s, isLoadingDownloadAttestato: true }));
    try {
        // Chiamiamo il nostro service, che si occuperà di tutto
        await AttestatiService.downloadAttestato(data, filename);
        alertService.success("Download avviato",{ autoClose: true });
    } catch (err) {
        console.error("❌ Errore in downloadAttestato:", err);
        handleError(err, "Errore nel download dell’attestato");
    } finally {
        setLoadingState((s) => ({ ...s, isLoadingDownloadAttestato: false }));
    }
};

  const stampaBustaAttestato = async (data) => {
    setLoadingState(prev => ({ ...prev, isPrintingEnvelope: true }));
    try {
        await AttestatiService.stampaBusta(data);
        // Il service si occupa del download, qui mostriamo solo la notifica.
        alertService.success("Download della busta avviato", { autoClose: true });
    } catch (err) {
        console.error("❌ Errore in stampaBustaAttestato:", err);
        handleError(err, "Errore nella generazione della busta");
    } finally {
        setLoadingState(prev => ({ ...prev, isPrintingEnvelope: false }));
    }
  };

const aggiornaSpedizioneAttestato = async (data) => {
        setLoadingState(prev => ({ ...prev, isLoadingUpdateSpedizione: true }));
        try {
            // Qui viene chiamato il servizio API
            await AttestatiService.aggiornaSpedizione(data);
            alertService.success("Dati spedizione aggiornati con successo", { autoClose: true });
            return true; // Ritorna true se la chiamata API ha successo
        } catch (err) {
            // ===== AGGIUNGI QUESTO CONSOLE.ERROR =====
            console.error("ERRORE DETTAGLIATO in aggiornaSpedizioneAttestato:", err);
            //=========================================
            handleError(err, "Errore nell'aggiornamento della spedizione");
            return false; // Ritorna false perché si è verificato un errore
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingUpdateSpedizione: false }));
        }
    };

  return {
    loadingStateAttestati: loadingState,
    generaAttestato,
    downloadAttestato,
    stampaBustaAttestato,
    modalStateAttestati: modalState,
    setModalStateAttestati: setModalState,
    aggiornaSpedizioneAttestato,
    stampaBustaAttestato, 
  };
};


export default useAttestati;
